import { axiosClient } from '@/libs/axios-client';

const BASE = '/compensation';

export const getEmployeeCompensation = async (employeeId) => {
  const { data } = await axiosClient.get(`${BASE}/employees/${employeeId}`);
  return data;
};

export const getCompensationCompanies = async () => {
  const { data } = await axiosClient.get(`${BASE}/companies`);
  return data?.items || [];
};

export const getCompanyCompensationList = async (companyId) => {
  const { data } = await axiosClient.get(
    `${BASE}/companies/${companyId}/employees`
  );
  return data?.items || [];
};

export const getSalaryViewers = async (companyId) => {
  const { data } = await axiosClient.get(
    `${BASE}/companies/${companyId}/viewers`
  );
  return data;
};

export const setSalaryViewers = async (companyId, userIds) => {
  const { data } = await axiosClient.put(
    `${BASE}/companies/${companyId}/viewers`,
    { userIds }
  );
  return data;
};

/** The closed AB payslip of a month as a PDF, saved by the browser. */
export const downloadPayslipPdf = async (employeeId, period, language) => {
  const response = await axiosClient.get(
    `${BASE}/employees/${employeeId}/payslips/${period}/pdf`,
    { params: { language }, responseType: 'blob' }
  );
  const name =
    /filename="([^"]+)"/.exec(response.headers?.['content-disposition'] || '')?.[1] ||
    `listic-${period}.pdf`;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
};
